<template>
<div class="grid flex justify-content-center mt-2 p-1 scalein animation-duration-500">
    <div class="md:col-12 sm:col-12 lg:col-10">
      <div class="grid flex lg:justify-content-center mt-2">
        <div class="lg:col-5 md:col-12 sm:col-12">
          <div class="w-full">
            <div class="grid">
              <div class="col-12">
                <Card class="p-1  border-round shadow-1">

                  <div class="col-12">
                    <Message :severity="Msg.Severity" class="w-full" :sticky="true" :closable="false"> {{ Msg.Content }}</Message>
                  </div>

                  <template #title>
                    <div class="text-xl text-500 mb-3">Enter your email to reset your password.</div>
                  </template>

                  <template #content>
                    <div class="col-12">
                      <span class="p-input-icon-right w-full mt-5">
                        <InputText class="w-full" @blur="v$.Email.$touch()" v-model="state.Email" />
                        <span v-if="v$.Email.$error" class="p-error m-1"> {{ v$.Email.$errors[0].$message }} </span>
                      </span>
                    </div>
                    <div class="col-12 flex md:justify-content-end">
                      <Button type="button" :label="BtnText" icon="pi pi-arrow-circle-right" iconPos="right" :loading="Resetting" :disabled="v$.$invalid || Resetting" @click="submit" class="w-100" id="Submit"/>
                    </div>
                    <Divider />
                    <div class="flex align-items-center justify-content-between mb-6">
                      <div class="flex align-items-center">
                        <Button type="button" label="Cancel" icon="pi pi-ban" iconPos="right" @click="RouteTo('/')" class="w-100 bg-red-700 border" style="border-color:none" />
                      </div>
                      <div class="flex align-items-center mt-2">
                        <span> <label>Remember your password? </label>   <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer" @click="RouteTo('/LoginHome')">Login here</a></span>
                      </div>
                    </div>
                  </template>
                </Card>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <Toast />
</template>

<style scoped>
  .p-inputwrapper {
    width: 100% !important;
  }

  #Submit {
    color: white;
    background: #ef7d1a !important;
    border-color: #ef7d1a;
  }
</style>

<script>

  /* eslint-disable no-debugger */

  //import Button from 'primevue/button';
  //import InputText from 'primevue/inputtext';
  //import Checkbox from 'primevue/checkbox';
  import useVuelidate from '@vuelidate/core'
  import { required, email, helpers } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'

  export default {
    name: 'ForgotPassword',
    components: {
  
    },
    data: () => ({
      loading:false,
      RememberMe: true,
      IsLoggingIn: false,
      BtnText: 'Send Reset Email',
      FailureMessage: null,
      IsLoginFailure: false,
      Resetting: false,
      Resending: false,
      ShowResend: false,
      ShowMessage: false,
      Msg: {
        Severity: null,
        Content: null,
      },
    }),
    created() {
      this.$emit("set-nav", this.$route)
    },
    setup() {

      const state = reactive({
        Email: '',
        Password: ''
      })
      const rules = computed(() => {
        return {
          Email: {
            required: helpers.withMessage("Email Address Is Required", required), email: helpers.withMessage("Input Must Be A Valid Email Address", email) },
        }
      });

      const v$ = useVuelidate(rules, state)
      return { state, v$}
    },
    methods: {
      Home() {
        this.$router.push('/')
      },
      RouteTo(path) {
        this.$router.push({path:path})
      },
      async submit(resend) {
        var self = this;
        if (resend == true) {
          self.Resending = true;
          self.Resetting = false;
        } else {
          self.BtnText = "Sending Reset Email..."
          self.Resending = false;
          self.Resetting = true;
        }
        self.ShowMessage = false;

        this.$http.post('/Authorization/ForgotPassword', { UserName: self.state.Email }).then(
          () => {
            self.$toast.add({ severity: 'success', summary: 'Password Reset Request', detail: 'Reset Email Sent Successfully ', life: 3000 });
            self.ShowMessage = true;
            self.ShowResend = true;
            self.Resending = false;
            self.Resetting = false;
            self.BtnText = "Send Reset Email";
          },
          (error) => {
            self.ShowMessage = true;
            self.Resending = false;
            self.Resetting = false;
            self.BtnText = "Send Reset Email"

            self.Msg.Severity = 'error';
            self.Msg.Content = self.$route.query.IsPw ? 'Error Sending Reset Link' : 'Error Sending Signup Email';
            if (error && error.response && error.response.status == 400) {
              self.Msg.Content = error.response.data.errors[0].description;
            }
          }
        );
      },
    }
  }
</script>